import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Modal from 'components/modal'
import Font from '@cred/react-font'
import actions from '@cred/react-modal/actions'
import { SnowplowContext } from '@cred/react-analytics/SnowplowContextManager'
import { component as SpComponent } from '@cred/react-analytics/contexts'
import CardTile from '../components/card-tile'
import styles from './styles.module.scss'

const MODAL_SUFFIX = '-modal',
  setModalName = name => `${name}${MODAL_SUFFIX}`,

  CardDetailsModal = ({ openModal, closeModal, card, ...props }) => (
    <>
      <SnowplowContext contexts={[SpComponent.analytics({ name: 'card details modal' })]}>
        <Font className={styles.showDetails} onClick={openModal}>Show Card Details</Font>
        <div className={styles.modal}>
          <Modal hideHeader withoutPadding name={setModalName(card.slug)}>
            <div className={styles.content}>
              <CardTile
                card={card}
                isModal
                closeModal={closeModal}
                {...props}
              />
              <div className={styles.cardFeatures}>
                <ul>
                  {card.marketingBullets
                    ? card.marketingBullets.map(({ bullet, uuid }) => (
                      <Font
                        type="disclaimer"
                        color="neutral"
                        element="li"
                        key={uuid}
                        className={styles.feature}
                        dangerouslySetInnerHTML={{ __html: bullet }}
                      />
                    ))
                    : ''}
                </ul>
              </div>
            </div>
            <div className={styles.footer}>
              <Font className="align-right" color="neutral" onClick={closeModal}>Close</Font>
            </div>
          </Modal>
        </div>
      </SnowplowContext>
    </>
  ),
  mapDispatchToProps = (dispatch, props) => {
    const { card } = props,
      { openModal, closeModal } = actions,
      modalName = setModalName(card.slug)

    return {
      openModal: () => dispatch(openModal(modalName)),
      closeModal: () => dispatch(closeModal(modalName)),
    }
  }

CardDetailsModal.propTypes = {
  card: PropTypes.object,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
}

export { CardDetailsModal, setModalName, mapDispatchToProps }

export default connect(
  null,
  mapDispatchToProps,
)(CardDetailsModal)
